import { useLocation, Outlet } from 'react-router';
import {
    LayoutGrid01,
    FileCheck02,
    HelpCircle,
    UserPlus01,
    BookOpen01,
    Clock,
    Package
} from '@untitledui/icons';
import { SidebarNavigationSimple } from '@/components/application/app-navigation/sidebar-navigation/sidebar-simple';
import { AICTACard } from '@/components/application/ai-chat/ai-cta-card';
import { HeaderNavigationBase } from '@/components/application/app-navigation/header-navigation';
import type { NavItemType } from '@/components/application/app-navigation/config';
import { useTranslation } from 'react-i18next';

export const FreightForwarderLayout = () => {
    const location = useLocation();
    const currentPath = location.pathname;
    const { t } = useTranslation('navigation');

    // Navigation items for sidebar - only Dashboard and Quotes
    const sidebarItems: NavItemType[] = [
        {
            label: t('dashboard'),
            href: '/freight-forwarder/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('quotes'),
            href: '/freight-forwarder/quotes',
            icon: FileCheck02
        },
        {
            label: t('containers'),
            href: '/freight-forwarder/containers',
            icon: Package
        },
        {
            label: t('activity'),
            href: '/freight-forwarder/activity',
            icon: Clock
        },
        {
            label: t('team'),
            href: '/freight-forwarder/team',
            icon: UserPlus01
        },
        {
            label: t('addressBook'),
            href: '/freight-forwarder/address-book',
            icon: BookOpen01
        }
    ];

    // Header navigation items
    const headerItems = [
        {
            label: t('dashboard'),
            href: '/freight-forwarder/dashboard',
            icon: LayoutGrid01
        },
        {
            label: t('quotes'),
            href: '/freight-forwarder/quotes',
            icon: FileCheck02
        },
        {
            label: t('containers'),
            href: '/freight-forwarder/containers',
            icon: Package
        },
        {
            label: t('activity'),
            href: '/freight-forwarder/activity',
            icon: Clock
        },
        {
            label: t('team'),
            href: '/freight-forwarder/team',
            icon: UserPlus01
        },
        {
            label: t('addressBook'),
            href: '/freight-forwarder/address-book',
            icon: BookOpen01
        }
    ];

    // Footer items for sidebar
    const footerItems: NavItemType[] = [
        {
            label: t('support'),
            href: '#',
            icon: HelpCircle
        },
    ];

    const env = import.meta.env.VITE_ENV;
    const hasEnvironmentBanner = env !== "production";

    return (
        <div className={`flex h-screen bg-secondary ${hasEnvironmentBanner ? "pt-7" : ""}`}>
            {/* Sidebar Navigation */}
            <SidebarNavigationSimple
                activeUrl={currentPath}
                items={sidebarItems}
                footerItems={footerItems}
                featureCard={<AICTACard />}
                showAccountCard={true}
                className="hidden lg:flex"
            />

            {/* Main Content */}
            <div className="flex flex-1 flex-col overflow-hidden">
                {/* Header Navigation */}
                <HeaderNavigationBase
                    activeUrl={currentPath}
                    items={headerItems}
                    showAvatarDropdown={true}
                />

                {/* Page Content */}
                <main className="flex-1 overflow-auto bg-secondary">
                    <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    );
};

